import React from "react";
import {DatePicker, Input, Rate, Table} from "antd";
import {Link} from "react-router-dom";
import {UserList} from "../../../models/employee";
import {AddEmployee} from "./popups/AddEmployee";
import {UpdateEmployee} from "./popups/UpdateEmployee";
import {pagination} from "../../../controller/Utils";
import {AnalyticsHeaderLink} from "../AnalyticsHeaderLink";

const moment = require('moment');
const {RangePicker} = DatePicker;
const Search = Input.Search;


export class EmployeeProfile extends React.Component {
  state = {
    visible: false,
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    update: false,
  };
  fetch = (params = {}) => {
    this.setState({loading: true, params: params});
    UserList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ...filters,
    });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'date_joined',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };
  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({selectedRowKeys});
  };
  onRowUpdateClick = (moderatedEmp) => {
    this.setState({moderatedEmp});
    this.setAddUpdateEmpVisible(true);
  };
  columns = [
    {
      title: 'View',
      render: (item) => <div className="action-column">
        <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil"/></a>
        <a title="Change Password"><i className="fa fa-key"/></a>
      </div>
    },
    {
      title: 'Employee Id',
      dataIndex: 'emp_id',
      sorter: true
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      sorter: true
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      sorter: true
    },
    {
      title: 'Joined Date',
      dataIndex: 'date_joined',
      render: date_joined => moment(date_joined).format('YYYY-MM-DD')
    },
    {
      title: 'Position',
      dataIndex: 'user_type',
    },
    {
      title: 'DOB',
      dataIndex: 'dob',
      sorter: true
    }, {
      title: 'Status',
      dataIndex: 'status',
      render: status => <span className={status ? 'completed' : 'pending'}><i className="fa fa-circle"/></span>
    }
  ];

  setAddUpdateEmpVisible(addUpdateEmpModel) {
    this.setState({addUpdateEmpModel});
    if (!addUpdateEmpModel)
      this.setState({moderatedEmp: addUpdateEmpModel})
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const {pagination, data, loading, selectedRowKeys} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Analytics</h3>
              </div>
              <div className="col-sm-9 col-12">
                <AnalyticsHeaderLink/>
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker onChange={this.onDateRangeChange}/>
                </div>
              </div>
              <div className="col-sm-3 col-12">
                <button className="btn submit-btn xs-hide" type="primary"
                        onClick={() => this.setAddUpdateEmpVisible(true)}>Create Employee
                </button>
              </div>
              <div className="col-sm-3 col-12">
                <Search placeholder="Input search text" onSearch={value => this.fetch({search: value})}
                        style={{width: 200}}/>
              </div>
              <div className="col-sm-2 col-12 edit-div">
                <span>{pagination.total} Records</span>
                <button className="btn btn-edit">
                  <i className="icon-printer"/>
                </button>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-12">
                <div className="listing-table">
                  <Table
                    className="report-table responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                    pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                    dataSource={data} loading={loading} onChange={this.handleTableChange}
                    locale={{emptyText: 'No Employee Available'}}/>
                </div>
              </div>
            </div>
            {this.state.moderatedEmp ?
              <UpdateEmployee moderated={this.state.moderatedEmp} visible={this.state.addUpdateEmpModel}
                              fetch={() => this.fetch()} setModelVisible={() => this.setAddUpdateEmpVisible(false)}/> :
              <AddEmployee visible={this.state.addUpdateEmpModel} fetch={() => this.fetch()}
                           setModelVisible={() => this.setAddUpdateEmpVisible(false)}/>}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/analytics/employee_profile/EmployeeProfile.jsx